import React, { createContext, useContext, useMemo } from 'react';
export const GlobalSpinnerContext = createContext({
    show: () => { },
    hide: () => { },
});
function getElems() {
    const spinner = document.querySelector('.wait-loading');
    const body = document.querySelector('body');
    const content = document.querySelector('#mainPageContent');
    if (!spinner || !body || !content)
        throw new Error('Missing global loading provider elements in the parent page!');
    return [spinner, body, content];
}
export function GlobalSpinnerProvider({ children }) {
    const [spinner, body, content] = getElems();
    const handlers = useMemo(() => ({
        show: () => {
            spinner.style.display = 'block';
            body.style.background = '#fff';
            content.style.display = 'none';
        },
        hide: () => {
            spinner.style.display = 'none';
            body.style.background = '';
            content.style.display = 'block';
        },
    }), []);
    return React.createElement(GlobalSpinnerContext.Provider, { value: handlers }, children);
}
export const useGlobalSpiner = () => useContext(GlobalSpinnerContext);
